export default __webpack_public_path__ + "static/media/imgLightQUALGO.f6670b68.png";